export const refundReportData = [
  {
    '#': '1',
    service: 'Plumbing service',
    provider: 'John Smith',
    customer: 'Hendy',
    amount: '$75',
    'requestedOn': '04 Oct 2023',
    'refundedOn': '07 Oct 2023',
    status: 'Completed',
  },
  {
    '#': '2',
    service: 'Car Repair Services',
    provider: 'Johnny',
    customer: 'Andy',
    amount: '$90',
    'requestedOn': '06 Oct 2023',
    'refundedOn': '10 Oct 2023',
    status: 'Inprogress',
  },
  {
    '#': '3',
    service: 'Steam Car Wash',
    provider: 'Amanda',
    customer: 'Melvin',
    amount: '$65',
    'requestedOn': '17 Oct 2023',
    'refundedOn': '15 Nov 2023',
    status: 'Pending',
  },
  {
    '#': '4',
    service: 'House Cleaning',
    provider: 'James',
    customer: 'Riswan',
    amount: '$90',
    'requestedOn': '17 Oct 2023',
    'refundedOn': '10 Oct 2023',
    status: 'Rejected',
  },
];
